// extracted by mini-css-extract-plugin
export default {"navLayoutContainer":"styles_navLayoutContainer__A1Pj0","navLayoutGoBackBtn":"styles_navLayoutGoBackBtn__RIef0"};